import {Component, OnInit, Input, Output, ViewChild} from '@angular/core';
import {LangChange} from '../../../../../../lang-change';
import {Language} from '../../../../../../common/models/language';
import {TranslateService} from '@ngx-translate/core';
import {EnrollCabinet} from '../../../model/enroll-cabinet';
import {EventEmitter} from 'events';
import {MatDialog} from '@angular/material';
import {AddParentsDialogComponent} from './add-parents-dialog/add-parents-dialog.component';
import {Utils} from '../../../../../../common/services/Utils';
import {EnrollParents} from '../../../model/enroll-parents';
import {CenterNationalityService} from '../../../../../user/services/center-nationality.service';
import {DicsEnrollCabinet} from "../../../model/dics-enroll-cabinet";
import {SimpleObject} from '../../../../../../common/dtos/SimpleObject';

declare var moment: any;

@Component({
  selector: 'app-enroll-personal-info',
  templateUrl: './enroll-personal-info.component.html',
  styleUrls: ['./enroll-personal-info.component.scss']
})
export class EnrollPersonalInfoComponent extends LangChange implements OnInit {

  maxFileSize = 5012000; // 5 MB
  iinIsIncorrect: boolean = true;
  isUnderEighteen = true;
  has_iin_items: SimpleObject[];
  constructor(public _translateService: TranslateService,
              private _centerNationalityService: CenterNationalityService,
              private dialog: MatDialog,
              private _nationalityService: CenterNationalityService,
              private utils: Utils) {
    super(_translateService);
  }

  @Input() public data: EnrollCabinet;
  @Input() public dics: DicsEnrollCabinet;
  @Input() public applicationFormDisabled: boolean;
  @ViewChild('photoFileInput') fileInputVariable;

  ngOnInit() {
    this.checkAge();
    this.getHasIINitems();
  }

  onLangChange(language: Language): void {
  }

  checkIinIsCorrect() {
    if (this.data.personal_info.iin && this.data.personal_info.iin.length === 12) {
      this.iinIsIncorrect = !this.utils.validateIin(this.data.personal_info.iin, this.data.personal_info.birth_date, this.data.personal_info.sex);
    }
    this.checkAge();
  }

  showIinGivedGosorganAlert() {
    if (!this.data.personal_info.iin_gived_gosorgan) {
      alert(this._translateService.instant('enroll_cabinet_page.personal_info_tab.iin_gived_gosorgan_notification'));
    }
  }

  getHasIINitems() {
    this.has_iin_items = new Array();
    this.has_iin_items.push(new SimpleObject(1,'Имеется'));
    this.has_iin_items.push(new SimpleObject(0,'Нет'));
  }

  addParentInfo(index?: number) {
    this.dialog.closeAll();
    const parent = new EnrollParents();
    if (index > -1) {
      Object.assign(parent, this.data.personal_info.parents[index]);
    }
    const dialogRef = this.dialog.open(AddParentsDialogComponent, {
      width: '50%',
      // height: '75%',
      disableClose: true,
      data: parent
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (index > -1) {
          this.data.personal_info.parents[index] = result;
        } else {
          this.data.personal_info.parents.push(result);
        }
      }
    });
  }

  deleteParentInfo(index: number) {
    if (index) {
      this.data.personal_info.parents.splice(index, 1);
    }
  }


  photoFileInputChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      if (fileInput.target.files[0].size > this.maxFileSize) {
        this.utils.notifyError(this._translateService.instant('enroll_cabinet_page.upload_file_size_exceed'), '');
        return false;
      } else {
        const file: File = fileInput.target.files[0];
        const myReader: FileReader = new FileReader();
        myReader.onloadend = (e) => {
          this.data.personal_info.enroll_photo = myReader.result;
        };
        myReader.readAsDataURL(file);
      }
    }
  }

  deleteFile() {
    this.utils.confirmDialog({message: 'delete_confirmation'}, () => {
      this.data.personal_info.enroll_photo = null;
    });
  }

  checkAge() {
    this.isUnderEighteen = this.calculateAge() < 18;
  }
  public calculateAge(): number {
    return moment().diff(this.data.personal_info.birth_date, 'years');
  }

  citizenshipChanged() {
    if (this.data.personal_info.citizenship === 113) {
      this.data.personal_info.has_iin = 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-personal-info/enroll-personal-info.component.ts